import React from 'react';
import { Switch, Route } from 'react-router-dom';
import RestrictedRoute from './RestrictedRoute';

import LoginPage from '../scenes/login/pages/LoginPage';
import WelcomePage from '../scenes/login/pages/WelcomePage';
import HomePage from '../scenes/home/pages/HomePage';
import ForgotPasswordPage from '../scenes/login/pages/ForgotPasswordPage';

import BrandsList from '../scenes/products/brands/pages/BrandsList';
import BrandEdit from '../scenes/products/brands/pages/BrandEdit';
import BrandCreate from '../scenes/products/brands/pages/BrandCreate';

import IngredientsList from '../scenes/products/ingredients/pages/IngredientsList';
import IngredientEdit from '../scenes/products/ingredients/pages/IngredientEdit';
import IngredientCreate from '../scenes/products/ingredients/pages/IngredientCreate';

import HsCodesList from '../scenes/products/hscodes/pages/HsCodesList';
import HsCodeEdit from '../scenes/products/hscodes/pages/HsCodeEdit';
import HsCodeCreate from '../scenes/products/hscodes/pages/HsCodeCreate';

import CategoriesList from '../scenes/products/categories/pages/CategoriesList';
import CategoryEdit from '../scenes/products/categories/pages/CategoryEdit';
import CategoryCreate from '../scenes/products/categories/pages/CategoryCreate';

import GenericProductsList from '../scenes/products/genericProducts/pages/GenericProductsList';
import GenericProductEdit from '../scenes/products/genericProducts/pages/GenericProductEdit';

import ManufacturersList from '../scenes/contractors/manufacturers/pages/ManufacturersList';
import ManufacturerEdit from '../scenes/contractors/manufacturers/pages/ManufacturerEdit';

import SuppliersList from '../scenes/contractors/suppliers/pages/SuppliersList';
import SupplierEdit from '../scenes/contractors/suppliers/pages/SupplierEdit';

import CustomersList from '../scenes/contractors/customers/pages/CustomersList';
import CustomerEdit from '../scenes/contractors/customers/pages/CustomerEdit';

import PalletsList from '../scenes/products/pallets/pages/PalletsList';
import PalletEdit from '../scenes/products/pallets/pages/PalletEdit';

import LabelsList from '../scenes/products/labels/pages/LabelsList';
import LabelEdit from '../scenes/products/labels/pages/LabelEdit';

import ContainersList from '../scenes/products/containers/pages/ContainersList';
import ContainerEdit from '../scenes/products/containers/pages/ContainerEdit';

import PackagesList from '../scenes/products/packages/pages/PackagesList';
import PackageEdit from '../scenes/products/packages/pages/PackageEdit';

import UserEdit from '../scenes/users/pages/UserEdit';

import OrdersList from '../scenes/orders/orders/pages/OrdersList';
import OrderEdit from '../scenes/orders/orders/pages/OrderEdit';
import OrderProductSelection from '../scenes/orders/orders/pages/OrderProductSelection';
import OrderProductsCalculations from '../scenes/orders/orders/pages/ProductsCalculations';
import OrderPrintout from '../scenes/orders/orders/pages/OrderPrintout';
import PalletDescription from '../scenes/orders/orders/pages/palletDescription/PalletDescriptions';
import PalletNumbering from '../scenes/orders/orders/pages/palletDescription/PalletNumbering';
import OrderReserve from '../scenes/orders/orders/pages/orderReserve/OrderReserve';
import Status from '../scenes/orders/orders/pages/Status/StatusDashboard';
import Proforma from '../scenes/orders/orders/pages/Proforma/Proforma';
import FnbOrdersList from '../scenes/orders/orders/pages/FnbOrdersList';
import FnbOrder from '../scenes/orders/orders/pages/FnbOrder';

import DataOperations from '../scenes/products/imports/pages/DataOperations';
import UploadForImport from '../scenes/products/imports/pages/UploadForImport';
import UploadForImportSizes from '../scenes/products/imports/pages/UploadForImportSizes';
import MatchChocolateToGtin from '../scenes/products/imports/pages/MatchChocolateToGtin';
import ProductPackingAnalysis from '../scenes/products/imports/pages/ProductPackingAnalysis';

import WarehousesList from '../scenes/warehouses/warehouses/pages/WarehousesList';
import WarehouseEdit from '../scenes/warehouses/warehouses/pages/WarehouseEdit';
import DisplayMatching from '../scenes/products/imports/pages/DisplayMatching';
import UploadForImportSupplierData from '../scenes/products/imports/pages/UploadForImportSupplierData';
import TransportPricingEdit from '../scenes/other/TransportPricing/pages/TransportPricingEdit';
import TransportPricingList from '../scenes/other/TransportPricing/pages/TransportPricingList';
import Invoice from '../scenes/orders/orders/pages/Invoice';

import InventoryMove from '../scenes/warehouses/inventory/pages/InventoryMove';
import InventoryAddSelectProduct from '../scenes/warehouses/inventory/pages/InventoryAddSelectProduct';
import InventoryEdit from '../scenes/warehouses/inventory/pages/InventoryEdit';
import InventoryAdd from '../scenes/warehouses/inventory/pages/InventoryAdd';
import InventoryAddFromTemplate from '../scenes/warehouses/inventory/pages/InventoryAddFromTemplate';
import InventoryAdjustment from '../scenes/warehouses/inventory/pages/InventoryAdjustment';
import InventoryForGeneric from '../scenes/warehouses/inventory/pages/InventoryForGeneric';
import InventorySplit from '../scenes/warehouses/inventory/pages/InventorySplit';
import InventoryRemove from '../scenes/warehouses/inventory/pages/InventoryRemove';
import InventoryRemoveEdit from '../scenes/warehouses/inventory/pages/InventoryRemoveEdit';
import Inventory from '../scenes/warehouses/inventory/pages/Inventory';
import InventoryImportExport from '../scenes/warehouses/inventory/pages/InventoryImportExport';
import MissingInventoryList from '../scenes/warehouses/inventory/pages/MissingInventoryList';
import InventoryForPurchaseOrder from '../scenes/warehouses/inventory/pages/InventoryForPurchaseOrder';

import NutritionHomepage from '../scenes/nutrition/pages/NutritionHomepage';
import ProductAnalysis from '../scenes/products/analysis/ProductAnalysis';
import { ROLES } from '../utils/constants';
import Forbidden from '../scenes/misc/pages/Forbidden';
import FnbProductsNoMatch from '../scenes/dataOperations/pages/FnbProductsNoMatch';
import PurchaseOrdersList from '../scenes/purchaseOrders/orders/pages/PurchaseOrdersList';
import PurchaseOrderEdit from '../scenes/purchaseOrders/orders/pages/PurchaseOrderEdit';
import PurchaseOrderProductsSelection from '../scenes/purchaseOrders/orders/pages/PurchaseOrderProductSelection';
import PurchaseProductsCalculations from '../scenes/purchaseOrders/orders/pages/PurchaseProductCalculations';
import PurchaseOrderReserve from '../scenes/purchaseOrders/orders/pages/orderReserve/PurchaseOrderReserve';
import OpTest from '../scenes/orders/orders/pages/OpTest';
import FnbConsolidationList from '../scenes/orders/orders/pages/FnbConsolidationList';
import FnbStatus from '../scenes/orders/orders/pages/FnbStatus';
import FnbConsolidationDetails from '../scenes/orders/orders/pages/FnbConsolidationDetails';
import SettingsPage from '../scenes/misc/pages/SettingsPage';
import PrintConsolidationList from '../scenes/orders/orders/pages/printConsollidation/PrintConsolidationList';
import TempOperations from '../scenes/products/imports/pages/TempOperations';
import FnbHangingOrders from '../scenes/dataOperations/pages/FnbHangingOrders';
import FnbProblematicConsolidations from '../scenes/dataOperations/pages/FnbProblematicConsolidations';
import InventoryReports from '../scenes/warehouses/inventory/pages/InventoryReports';
import InventoryReportsIncoming from '../scenes/warehouses/inventory/pages/InventoryReportsIncoming';
import InventoryReportsOutgoing from '../scenes/warehouses/inventory/pages/InventoryReportsOutoging';
import StorageConditionsList from '../scenes/warehouses/storageConditions/StorageConditionsList';
import StorageConditionsEdit from '../scenes/warehouses/storageConditions/StorageConditionsEdit';
import DeliveriesList from '../scenes/orders/orders/pages/Deliveries/DeliveriesList';
import DeliveryForm from '../scenes/orders/orders/pages/Deliveries/DeliveryForm';
import PalletDescriptionPrint from '../scenes/orders/orders/pages/palletDescription/PalletDescriptionPrint';
import UsersList from '../scenes/users/pages/UsersList';
import FnbInvoiceList from '../scenes/orders/orders/pages/FnbInvoiceList';
import FnbInvoiceEdit from '../scenes/orders/orders/pages/FnbInvoiceEdit';
import WarehouseOwnerList from '../scenes/contractors/warehouseOwners/pages/WarehouseOwnerList';
import WarehouseOwnerEdit from '../scenes/contractors/warehouseOwners/pages/WarehouseOwnerEdit';
import PrintLotReport from '../scenes/orders/orders/pages/PrintLotReport';
import ExternalOrders from '../scenes/externalOrders/ExternalOrders';
import MarginsList from '../scenes/other/Margins/pages/MarginsList';
import MarginEdit from '../scenes/other/Margins/pages/MarginEdit';

import SvilaClientsList from '../scenes/svilaClients/pages/SvilaClientsList';
import SvilaClientEdit from '../scenes/svilaClients/pages/SvilaClientEdit';
import InventoryForWarehouse from '../scenes/warehouses/inventory/pages/InventoryForWarehouse';
import InventoryForGenericInWarehouse from '../scenes/warehouses/inventory/pages/InventoryForGenericInWarehouse';
import IntegrationsList from '../scenes/intergrations/pages/IntegrationsList';
import IntegrationEdit from '../scenes/intergrations/pages/IntegrationEdit';
import GombaProductsList from '../scenes/gomba/pages/products/GombaProductsList';

const AppRoutes = () => (
  <Switch>
    <Route exact path="/">
      <WelcomePage />
    </Route>
    <Route exact path="/login">
      <LoginPage />
    </Route>
    <Route exact path="/forgot">
      <ForgotPasswordPage />
    </Route>
    <Route exact path="/403">
      <Forbidden />
    </Route>
    <RestrictedRoute exact path="/home" component={<HomePage />} />

    <RestrictedRoute
      exact
      path="/brands"
      component={<BrandsList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/brands/create"
      component={<BrandCreate />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/brands/edit/:id"
      component={<BrandEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />

    <RestrictedRoute
      exact
      path="/ingredients"
      component={<IngredientsList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/ingredients/create"
      component={<IngredientCreate />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/ingredients/edit/:id"
      component={<IngredientEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/hscodes"
      component={<HsCodesList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/hscodes/create"
      component={<HsCodeCreate />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/hscodes/edit/:id"
      component={<HsCodeEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />

    <RestrictedRoute
      exact
      path="/products"
      component={<GenericProductsList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.OFFICE, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/products/create"
      component={<GenericProductEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.OFFICE, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/products/edit/:id"
      component={<GenericProductEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.OFFICE, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />

    <RestrictedRoute
      exact
      path="/categories"
      component={<CategoriesList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/categories/create"
      component={<CategoryCreate />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/categories/edit/:id"
      component={<CategoryEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />

    <RestrictedRoute
      exact
      path="/manufacturers"
      component={<ManufacturersList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}
    />
    <RestrictedRoute
      exact
      path="/manufacturers/create"
      component={<ManufacturerEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}
    />
    <RestrictedRoute
      exact
      path="/manufacturers/edit/:id"
      component={<ManufacturerEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}
    />

    <RestrictedRoute
      exact
      path="/suppliers"
      component={<SuppliersList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/suppliers/create"
      component={<SupplierEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/suppliers/edit/:id"
      component={<SupplierEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />

    <RestrictedRoute
      exact
      path="/customers"
      component={<CustomersList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.WAREHOUSE_EXTERNAL_USER, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/customers/create"
      component={<CustomerEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.WAREHOUSE_EXTERNAL_USER, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/customers/edit/:id"
      component={<CustomerEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/warehouse-owners"
      component={<WarehouseOwnerList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/warehouse-owners/create"
      component={<WarehouseOwnerEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/warehouse-owners/edit/:id"
      component={<WarehouseOwnerEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/pallets"
      component={<PalletsList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/pallets/create"
      component={<PalletEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/pallets/edit/:id"
      component={<PalletEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/labels"
      component={<LabelsList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/labels/create"
      component={<LabelEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/labels/edit/:id"
      component={<LabelEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/containers"
      component={<ContainersList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/containers/create"
      component={<ContainerEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/containers/edit/:id"
      component={<ContainerEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />

    <RestrictedRoute
      exact
      path="/packages"
      component={<PackagesList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/packages/create"
      component={<PackageEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/packages/edit/:id"
      component={<PackageEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />

    <RestrictedRoute exact path="/users" component={<UsersList />} roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN]} />
    <RestrictedRoute
      exact
      path="/users/create"
      component={<UserEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/users/edit/:id"
      component={<UserEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/settings"
      component={<SettingsPage />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/orders-list"
      component={<OrdersList />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />

    <RestrictedRoute
      exact
      path="/orders/fnb"
      component={<FnbOrdersList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/orders/fnb-invoices"
      component={<FnbInvoiceList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/orders/fnb-invoices/:id"
      component={<FnbInvoiceEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/orders/fnb/:orderId"
      component={<FnbOrder />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.FNB,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/fnb-consolidations"
      component={<FnbConsolidationList />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/fnb-consolidation-details/:orderId"
      component={<FnbConsolidationDetails />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/print/:id"
      component={<PrintConsolidationList />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/print-lot-report/:id"
      component={<PrintLotReport />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/fnb-status"
      component={<FnbStatus />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.FNB, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/orders/create"
      component={<OrderEdit />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.DATABASE_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT,
      ]}
    />

    <RestrictedRoute
      exact
      path="/orders/edit/:id"
      component={<OrderEdit />}
    // roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE]} // Add details
    />
    <RestrictedRoute
      exact
      path="/purchase-orders"
      component={<PurchaseOrdersList />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/purchase-orders/create"
      component={<PurchaseOrderEdit />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.DATABASE_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/purchase-delivery/create/:id"
      component={<DeliveryForm />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.DATABASE_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/purchase-orders/edit/:id"
      component={<PurchaseOrderEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/purchase-delivery/edit/:id"
      component={<DeliveryForm />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.DATABASE_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/purchase-orders/edit/:id"
      component={<PurchaseOrderEdit />}
    // roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE]} // Add details
    />
    <RestrictedRoute
      exact
      path="/purchase-delivery/:id"
      component={<DeliveriesList />}
    // roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE]} // Add details
    />
    <RestrictedRoute
      exact
      path="/optest/:id"
      component={<OpTest />}
    // roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE]} // Add details
    />
    <RestrictedRoute
      exact
      path="/purchase-orders/details/:id"
      component={<PurchaseOrderProductsSelection />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/purchase-orders/calculations/:id"
      component={<PurchaseProductsCalculations />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.OFFICE, ROLES.SALES, ROLES.WAREHOUSE_EXTERNAL_USER, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/purchase-orders/reserve/:id"
      component={<PurchaseOrderReserve />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.OFFICE, ROLES.SALES, ROLES.WAREHOUSE_EXTERNAL_USER]}
    />
    <RestrictedRoute
      exact
      path="/orders/details/:id"
      component={<OrderProductSelection />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/details/:id/:consolidation"
      component={<OrderProductSelection />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SALES, ROLES.OFFICE, ROLES.DATABASE_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/orders/calculations/:id"
      component={<OrderProductsCalculations />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN
      ]}
    />

    <RestrictedRoute
      exact
      path="/orders/printout/:id"
      component={<OrderPrintout />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.WAREHOUSE_EXTERNAL_USER,
      ]}
    />

    <RestrictedRoute
      exact
      path="/orders/printout/:id/:consolidation"
      component={<OrderPrintout />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE, ROLES.WAREHOUSE_ADMIN, ROLES.SALES, ROLES.OFFICE]}
    />
    <RestrictedRoute
      exact
      path="/orders/pallet-description/:id"
      component={<PalletDescription />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/pallet-description/print/:id"
      component={<PalletDescriptionPrint />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/pallet-numbering/:id"
      component={<PalletNumbering />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/reserve/:id"
      component={<OrderReserve />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.OFFICE, ROLES.SALES,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/orders/reserve/:id/:consolidation"
      component={<OrderReserve />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.OFFICE, ROLES.SALES]}
    />
    <RestrictedRoute
      exact
      path="/orders/status/:id"
      component={<Status />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/status/:id/:consolidation"
      component={<Status />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE, ROLES.WAREHOUSE_ADMIN, ROLES.OFFICE, ROLES.SALES]}
    />
    <RestrictedRoute
      exact
      path="/orders/proforma/:id"
      component={<Proforma />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.SALES,
        ROLES.OFFICE,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/orders/invoice/:id"
      component={<Invoice />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.SALES,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/orders/invoice/:id/:consolidation"
      component={<Invoice />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SALES, ROLES.WAREHOUSE, ROLES.WAREHOUSE_ADMIN, ROLES.OFFICE]}
    />
    <RestrictedRoute
      exact
      path="/data-operations"
      component={<DataOperations />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/products/imports/upload"
      component={<UploadForImport />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/products/import-sizes/upload"
      component={<UploadForImportSizes />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/products/import-supplier-data/upload"
      component={<UploadForImportSupplierData />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/products/imports/match"
      component={<MatchChocolateToGtin />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/products/imports/display-matches"
      component={<DisplayMatching />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/products/products/packings"
      component={<ProductPackingAnalysis />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/products/analysis"
      component={<ProductAnalysis />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/fnb/products-no-match"
      component={<FnbProductsNoMatch />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/fnb/fnb-hanging"
      component={<FnbHangingOrders />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/fnb/fnb-problematic-consolidations"
      component={<FnbProblematicConsolidations />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />

    <RestrictedRoute
      exact
      path="/gomba/products"
      component={<GombaProductsList />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />

    <RestrictedRoute
      exact
      path="/warehouses"
      component={<WarehousesList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/warehouses/create"
      component={<WarehouseEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/warehouses/edit/:id"
      component={<WarehouseEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/transport-pricings"
      component={<TransportPricingList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}
    />
    <RestrictedRoute
      exact
      path="/transport-pricings/create"
      component={<TransportPricingEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}
    />
    <RestrictedRoute
      exact
      path="/transport-pricings/edit/:id"
      component={<TransportPricingEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}
    />

    <RestrictedRoute
      exact
      path="/margins"
      component={<MarginsList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}
    />
    <RestrictedRoute
      exact
      path="/margins/create"
      component={<MarginEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}
    />
    <RestrictedRoute
      exact
      path="/margins/edit/:id"
      component={<MarginEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}
    />

    {/* Inventory */}

    <RestrictedRoute
      exact
      path="/inventory/edit/:genericId"
      component={<InventoryEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/inventory/edit-remove"
      component={<InventoryRemoveEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/inventory/add/:genericId"
      component={<InventoryAdd />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT,]}
    />
    <RestrictedRoute
      exact
      path="/inventory/add-from-template/:genericId"
      component={<InventoryAddFromTemplate />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/inventory/adjustment/:genericId"
      component={<InventoryAdjustment />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/inventory/remove/:genericId"
      component={<InventoryRemove />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/inventory/list-for-generic/:id"
      component={<InventoryForGeneric />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
      ]}
    />
    <RestrictedRoute
      exact
      path="/inventory/list-for-generic/in-warehouse/:warehouseId/:genericProductId"
      component={<InventoryForGenericInWarehouse />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT
      ]}
    />
    <RestrictedRoute
      exact
      path="/inventory"
      component={<Inventory />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.WAREHOUSE_EXTERNAL_USER,
      ]}
    />
    <RestrictedRoute
      exact
      path="/inventory/for-warehouse/:warehouseId"
      component={<InventoryForWarehouse />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/inventory/split/:genericId"
      component={<InventorySplit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/inventory/select-product"
      component={<InventoryAddSelectProduct />}
      roles={[
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.SVILA_CLIENT_ADMIN,
        ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/inventory/move"
      component={<InventoryMove />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE, ROLES.WAREHOUSE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/inventory/import-export"
      component={<InventoryImportExport />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/inventory/missing"
      component={<MissingInventoryList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.WAREHOUSE_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/inventory/reports"
      component={<InventoryReports />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/inventory/reports/incoming"
      component={<InventoryReportsIncoming />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/inventory/reports/outgoing"
      component={<InventoryReportsOutgoing />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/inventory/purchase-order/:id"
      component={<InventoryForPurchaseOrder />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.WAREHOUSE_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/inventory/migrate-remove"
      component={<TempOperations />}
      roles={[ROLES.SUPER_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/storage-conditions"
      component={<StorageConditionsList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/storage-conditions/create"
      component={<StorageConditionsEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />
    <RestrictedRoute
      exact
      path="/storage-conditions/edit/:id"
      component={<StorageConditionsEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}
    />

    <RestrictedRoute
      exact
      path="/svila-clients"
      component={<SvilaClientsList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/svila-clients/create"
      component={<SvilaClientEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/svila-clients/edit/:id"
      component={<SvilaClientEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]}
    />

    <RestrictedRoute
      exact
      path="/integrations"
      component={<IntegrationsList />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/integrations/create"
      component={<IntegrationEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/integrations/edit/:id"
      component={<IntegrationEdit />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}
    />


    <RestrictedRoute
      exact
      path="/nutrition"
      component={<IngredientCreate />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/nutrition/ingredient/:ingredientId"
      component={<NutritionHomepage />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/nutrition/:productId"
      component={<NutritionHomepage />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />
    <RestrictedRoute
      exact
      path="/external-orders-list"
      component={<ExternalOrders />}
      roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}
    />

    {/*
    Not Found 
      <Route component={NotFound}  roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]} />
      */}
  </Switch>
);
export default AppRoutes;
